export default class extends HTMLElement {
  async connectedCallback () {
    const password = await window.Dialog.prompt(this.dataset.message || 'Enter PDF password', { inputType: 'password', required: true })

    if (password === null) {
      this.remove()

      return
    }

    const input = document.createElement('input')

    input.type = 'hidden'
    input.name = 'password'
    input.value = password

    this.form.append(input)

    this.form.requestSubmit()

    this.remove()
  }

  get form () {
    return this.closest('form')
  }
}
